import { BONUS_TYPE } from '~/components/BigModal/RegAuthForgot/RegistrationBonuses'
import { createState } from '~/util/storeHelpers'

const toGrn = (coins) => coins / 100
const registerBonuses = createState({ key: 'registerBonuses', initialValue: [] })
export const state = () => ({
  registerBonuses: registerBonuses.state,
  activatedBonusesByPromoCode: [], // in current session in the RegistrationBonuses modal
  activeBonus: {}, // for cashbox
  activatedBonusesCodesFromRegister: [],
})

export const mutations = {
  set_registerBonuses: registerBonuses.setter,
  set_activatedBonusesCodesFromRegister(state, activatedBonusesCodesFromRegister) {
    state.activatedBonusesCodesFromRegister = activatedBonusesCodesFromRegister
  },
  reset_activatedBonusesByPromoCode(state, bonusObj) {
    state.activatedBonusesByPromoCode = []
  },
  push_activatedBonusesByPromoCode(state, bonusObj) {
    state.activatedBonusesByPromoCode.push(bonusObj)
  },
  set_activeBonus(state, data) {
    state.activeBonus = data
  },
}

export const actions = {
  actSet_activatedBonusesCodesFromRegister({ commit }, { promotionsCodes = [] }) {
    commit('set_activatedBonusesCodesFromRegister', promotionsCodes)
  },
  actReset_activatedBonusesByPromoCode({ commit }) {
    commit('reset_activatedBonusesByPromoCode')
  },
  actPush_activatedBonusesByPromoCode({ commit }, bonusObj) {
    commit('push_activatedBonusesByPromoCode', bonusObj)
  },
  async fetch_registerBonuses({ commit }) {
    try {
      commit('set_registerBonuses', { isLoading: true })
      const res = await this.$api.userPromotions.getRegisterBonuses()
      if (!res || !res?.data || !res?.data?.status) {
        commit('set_registerBonuses', { error: true })
      }
      else {
        commit('set_registerBonuses', { error: null })
        commit('set_registerBonuses', { data: res?.data?.promotions })
      }
    }
    catch (err) {
      commit('set_registerBonuses', { error: err })
    }
    finally {
      commit('set_registerBonuses', { isLoading: false })
    }
  },
  activeBonus({ commit }, item) {
    commit('set_activeBonus', item)
  },
}

export const getters = {
  getData_registerBonuses: registerBonuses.getter,
  get_promocodeBonuses: (state, getters) => {
    let maxIndex
    let max = 0
    const res = getters.getData_registerBonuses.data
      .filter(item => item.is_promocode)
      .map((bonus, index) => {
        bonus.bonusType = BONUS_TYPE.PROMO_CODE
        bonus.isPromocodeBonus = true
        bonus.minDepositGrn = toGrn(bonus.min_deposit)
        if (bonus.min_deposit > max) {
          max = bonus.min_deposit
          maxIndex = index
        }
        return bonus
      })
    if (res.length) res[maxIndex].isMaxMinDepositInPromocodes = true
    return res
  },
  get_welcomePackBonusesData: (_, getters) => getters.getData_registerBonuses.data.find(item => item.is_welcome_pack),
  get_welcomePackBonusesDataVip: (_, getters) => getters.getData_registerBonuses.data.find(item => item.іs_vip_welcome_pack),
  get_welcomePackBonuses: (_, getters) => {
    const groups = getters.get_welcomePackBonusesData?.groups || []
    return [...groups]
      .sort((a, b) => b.min_deposit - a.min_deposit)
      .map(bonus => {
        bonus.bonusType = BONUS_TYPE.WELCOME_PACK
        return bonus
      })
  },
  get_welcomePackBonusesVip: (_, getters) => {
    const groupsVip = getters.get_welcomePackBonusesDataVip
    if (!groupsVip) return []
    return [groupsVip]
      .sort((a, b) => b.min_deposit - a.min_deposit)
      .map(bonus => {
        bonus.isVip = true
        bonus.bonusType = BONUS_TYPE.WELCOME_PACK_VIP
        return bonus
      })
  },
  get_registerBonusesOther: (_, getters) => {
    return getters.getData_registerBonuses.data
      .filter(b => !b.іs_vip_welcome_pack)
      .filter(b => !b.is_welcome_pack)
      .filter(b => !b.is_promocode)
  },
  get_registerBonuses: (_, getters) => {
    /** fix several promos */
    if (!getters.get_welcomePackBonuses.length) return []
    const sortedAscending = [...getters.get_welcomePackBonuses]
      .sort((a, b) => a.min_deposit - b.min_deposit)
      .map((bonus) => {
        bonus.minDepositGrn = toGrn(bonus.min_deposit)
        return bonus
      })
    let restFromWelcomePack = []
    if (getters.get_welcomePackBonuses.length >= 3) restFromWelcomePack = sortedAscending.slice(1, sortedAscending.length - 1)
    const min = sortedAscending[0]
    const max = sortedAscending.at(-1)
    max.isTop = true
    const formatedArray =    [
      min,
      max,
      ...restFromWelcomePack,
      ...getters.get_welcomePackBonusesVip,
      ...getters.get_registerBonusesOther,
      ...getters.get_promocodeBonuses,
      ...getters.get_activatedBonusesByPromoCode,
    ]
    const indexVip = formatedArray.findIndex(item => item.isVip === true)
    const [itemVip] = formatedArray.splice(indexVip, 1)

    formatedArray.splice(formatedArray.length, 0, itemVip)
    return formatedArray
  },
  get_registerBonusesTotalCount: (_, getters) => getters.get_registerBonuses.length,
  get_activatedBonusesCodesFromRegister: (state) => state.activatedBonusesCodesFromRegister,
  get_activatedBonusesByPromoCode: (state) => state.activatedBonusesByPromoCode
    .map((bonus) => {
      bonus.isPromocodeBonus = true
      bonus.bonusType = BONUS_TYPE.PROMO_CODE
      bonus.minDepositGrn = toGrn(bonus.min_deposit)
      return bonus
    }),
}
